import { gql } from '@apollo/client';

// Fragment for content fields
export const CONTENT_FIELDS_FRAGMENT = gql`
  fragment ContentFields on Content {
    id
    file_name
    mime_type
    size
    processing_status
    download_url
    created_at
    updated_at
    type
    metadata {
      width
      height
      duration
      size
      mime_type
    }
    user_id
  }
`;

// Upload content mutation
export const UPLOAD_CONTENT = gql`
  mutation uploadContent($file: Upload!) {
    uploadContent(file: $file) {
      success
      message
      content {
        id
        file_name
        size
        mime_type
        processing_status
        download_url
        media_conversions {
          original
          small
          medium
        }
        applause_count
        comment_count
        is_applauded
        is_reported
        user {
          id
          name
          nickname
          profile_photo_urls {
            thumbnail
            small
            medium
          }
        }
        created_at
        updated_at
      }
    }
  }
`;

// Get user's content
export const GET_USER_CONTENT = gql`
  query getUserContent(
    $user_id: ID!
    $page: Int = 1
    $perPage: Int = 15
  ) {
    userContent(
      user_id: $user_id
      page: $page
      perPage: $perPage
    ) {
      data {
        id
        file_name
        size
        mime_type
        processing_status
        download_url
        media_conversions {
          original
          small
          medium
        }
        applause_count
        comment_count
        is_applauded
        is_reported
        user {
          id
          name
          nickname
          bio
          profile_photo_urls {
            thumbnail
            small
            medium
          }
          followers_count
          following_count
          applauses_count
          is_followed
          is_follower
          is_me
        }
        created_at
        updated_at
      }
      paginatorInfo {
        total
        count
        currentPage
        lastPage
        firstItem
        lastItem
        perPage
        hasMorePages
      }
    }
  }
`;

// Get single content item
export const GET_CONTENT = gql`
  query GetContent($id: ID!) {
    getContent(id: $id) {
      ...ContentFields
    }
  }
  ${CONTENT_FIELDS_FRAGMENT}
`;

// Delete content
export const DELETE_CONTENT = gql`
  mutation DeleteContent($id: ID!) {
    deleteContent(id: $id) {
      success
      message
    }
  }
`;

// Check content processing status
export const CHECK_CONTENT_STATUS = gql`
  query CheckContentStatus($id: ID!) {
    checkContentStatus(id: $id) {
      id
      processing_status
      download_url
    }
  }
`;

// Get latest content for discover page
export const GET_LATEST_CONTENT = gql`
  query getLatestContent($page: Int = 1, $perPage: Int = 15) {
    latestContent(page: $page, perPage: $perPage) {
      data {
        id
        file_name
        size
        mime_type
        processing_status
        download_url
        media_conversions {
          original
          small
          medium
        }
        
        applause_count
        comment_count
        is_applauded
        is_reported
        user {
          id
          name
          nickname
          bio
          profile_photo_urls {
            thumbnail
            small
            medium
          }
          followers_count
          following_count
          applauses_count
          is_followed
          is_follower
          is_me
        }
        created_at
        updated_at
      }
      paginatorInfo {
        total
        count
        currentPage
        lastPage
        firstItem
        lastItem
        perPage
        hasMorePages
      }
    }
  }
`;

// Toggle applause mutation
export const TOGGLE_APPLAUSE = gql`
  mutation toggleApplause($content_id: ID!) {
    toggleApplause(content_id: $content_id) {
      id
      file_name
      applause_count
      is_applauded
      user {
        id
        name
        nickname
        applauses_count
        profile_photo_urls {
          thumbnail
          small
          medium
        }
      }
      media_conversions {
        original
        small
        medium
      }
      created_at
    }
  }
`;

// Get content by ID with comments
export const GET_CONTENT_BY_ID = gql`
  query getContentById($id: ID!) {
    contentById(id: $id) {
      id
      file_name
      size
      mime_type
      processing_status
      download_url
      media_conversions {
        original
        small
        medium
      }
      applause_count
      comment_count
      is_applauded
      is_reported
      user {
        id
        name
        nickname
        bio
        profile_photo_urls {
          thumbnail
          small
          medium
        }
        followers_count
        following_count
        applauses_count
        is_followed
        is_follower
        is_me
      }
      comments(page: 1, perPage: 5) {
        data {
          id
          text
          user {
            id
            name
            nickname
            profile_photo_urls {
              thumbnail
              small
              medium
            }
          }
          created_at
        }
        paginatorInfo {
          total
          hasMorePages
        }
      }
      created_at
      updated_at
    }
  }
`;

// Get content comments
export const GET_CONTENT_COMMENTS = gql`
  query getContentComments(
    $content_id: ID!
    $page: Int = 1
    $perPage: Int = 15
    $top_level_only: Boolean = true
  ) {
    contentComments(
      content_id: $content_id
      page: $page
      perPage: $perPage
      top_level_only: $top_level_only
    ) {
      data {
        id
        text
        user {
          id
          name
          nickname
          profile_photo_urls {
            thumbnail
            small
            medium
          }
        }
        parent {
          id
          text
          user {
            name
            nickname
          }
        }
        replies(page: 1, perPage: 5) {
          data {
            id
            text
            user {
              id
              name
              nickname
            }
            created_at
          }
          paginatorInfo {
            total
            hasMorePages
          }
        }
        created_at
        updated_at
      }
      paginatorInfo {
        total
        count
        currentPage
        lastPage
        hasMorePages
        perPage
      }
    }
  }
`; 